import React from 'react';
import Fireworks from "react-canvas-confetti/dist/presets/fireworks";

export default function AutoConfetti() {
  return <Fireworks autorun={{ speed: 1, duration: 1000 }} />;
}